import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { MusicControl } from './types';

export function useMusicControl(screenId: string | undefined, locationId: string | null | undefined, groupId: number | null | undefined) {
  const queryClient = useQueryClient();
  const serverUrl = import.meta.env.VITE_SERVER_URL ?? "";

  const { data: controlInfo, isLoading } = useQuery<MusicControl>({
    queryKey: ['music-control', screenId, locationId, groupId],
    enabled: !!screenId && !!locationId && !!groupId,
    async queryFn() {
      const response = await fetch(`${serverUrl}/musicControl`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          screenId,
          locationId,
          action: 'get',
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch control info');
      }

      return response.json();
    },
  });

  const requestControl = useMutation(
    {
      async mutationFn() {
        const response = await fetch(`${serverUrl}/musicControl`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            screenId,
            locationId,
            action: 'request',
          }),
        });

        if (!response.ok) {
          throw new Error('Failed to request control');
        }

        return response.json();
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['music-control', screenId, locationId]
        });
      },
    }
  );

  return {
    controlInfo,
    isLoading,
    requestControl,
  };
}